import { path } from 'ramda'

/**
 * Order changes store actions.
 *
 * @param {FetchPath} fetchPath
 * @return {Object}
 */
export default ({ fetchPath }) => ({
  /**
   * Clears the order changes stored in the state.
   *
   * @param {Function} commit
   */
  clear({ commit }) {
    commit('SET', null)
  },

  /**
   * Loads the changes made to a given order.
   *
   * @param {Function} commit
   * @param {Number} orderId
   * @return {Promise}
   */
  async xhrLoad({ commit }, { orderId }) {
    const response = await fetchPath.run({
      method: 'GET',
      path: `/yoda/api/sales-negotiations/${orderId}/changes`,
    })
    const orderChanges = path(['content'], response)

    commit('SET', orderChanges)

    return orderChanges
  },
})
